import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbRelatorioAcionamentos } from 'app/abstract/full-pages/relatorios/relatorio-acionamento.abstract';

@Injectable({ providedIn: 'root' })
export class RelatorioAcionamentosServices extends AbRelatorioAcionamentos {

    constructor(http: HttpClient) {
        super(http);
    }

    getRelatorioAberturaporta(filter: String): Observable<any> {
        return this.get(`relatorio_acionamento/listar/${filter}`);
    }

    getRelatorio(filter: string): Observable<any> {
        return this.get(`relatorio_acionamento/gerar/${filter}`);
    }

    getPortas(): Observable<any> {
        return this.get("relatorio_acionamento/portas");
    }

}